<div class="w-full bg-transparent max-h-8 gap-2 sm:gap-4 h-full flex flex-wrap justify-center sm:justify-end items-center">
    <div class="flex gap-2 sm:gap-3 items-center text-xs sm:text-sm">
        <span class="text-[#333333]">Rows per page</span>
        <div class="relative w-16 sm:w-20">
            <select [(ngModel)]="itemsPerPage" (ngModelChange)="navigateToPage(1)"
                class="appearance-none w-full text-indigo-600 text-xs sm:text-sm px-2 sm:px-4 py-1 sm:py-2 font-semibold bg-transparent border-b-2 border-indigo-600 focus:outline-none focus:ring-0 focus:border-indigo-700 cursor-pointer">
                <option value="5">5</option>
                <option selected value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
            </select>
            <div class="absolute inset-y-0 right-1 sm:right-2 flex items-center pointer-events-none">
                <svg class="w-3 h-3 sm:w-4 sm:h-4 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
            </div>
        </div>
    </div>
    <div class="text-xs sm:text-sm gap-2 flex">{{ showingFrom }} - {{ showingTo }} of {{ totalItems }}</div>
    <div class="flex gap-1 sm:gap-2 items-center">
        <button (click)="handlePrevClick()" [disabled]="currentPage === 1" class="cursor-pointer">
            <i [ngClass]="{'text-gray-400': currentPage === 1}" class='bx bxs-chevron-left p-2 sm:p-3 rounded-full active:bg-white'></i>
        </button>
        <button (click)="handleNextClick()" [disabled]="showingTo >= totalItems" class="cursor-pointer">
            <i [ngClass]="{'text-gray-400': showingTo >= totalItems}" class='bx bxs-chevron-right p-2 sm:p-3 rounded-full active:bg-white'></i>
        </button>
    </div>
</div>